import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import {
    Component,
    HostListener,
    Inject,
    OnDestroy,
    OnInit,
    PLATFORM_ID,
    TemplateRef,
} from '@angular/core';
// ** rxjs
import { of } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
// ** service
import { LayoutService } from '@app/core/services/layout.service';
import { LanguageService, Language } from '../../core/services/language.service';

@Component({
    selector: 'app-nav-header',
    templateUrl: './nav-header.component.html',
    styleUrls: ['./nav-header.component.scss'],
})
export class NavHeaderComponent implements OnInit, OnDestroy {
    isCollapsed = true;
    isOpened = false;
    isBrowser = false;
    dropdownStates: { [key: string]: boolean } = {};
    dropdownKeys = Object.keys(this.dropdownStates); // dropdown 的 key

    public getScreenWidth: any;
    public loading: boolean;
    public loadingTemplate!: TemplateRef<any>;
    private dropdownTimeout: any = {};

    // 語系相關屬性
    public languages: Language[] = [];
    public selectedLanguage: string = 'zh-tw';

    @HostListener('window:resize', ['$event'])
    onResize(event: Event): void {
        this.onWindowResize(event);
    }

    constructor(
        @Inject(DOCUMENT) private document: Document,
        @Inject(PLATFORM_ID) private platformId,
        public layoutService: LayoutService,
        private languageService: LanguageService,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    onWindowResize(e) {
        this.getScreenWidth = window.innerWidth;
        if (this.getScreenWidth > 1023) {
            this.isCollapsed = true;
            const element1 = this.document.querySelector('.wrapper');
            const element2 = this.document.querySelector('.navbar-collapse');
            const element3 = this.document.querySelector('html');

            if (element1) {
                element1?.classList.remove('filter_blur_2px');
            }

            if (element2) {
                element2?.classList.remove('filter_blur_2px');
            }

            if (element3) {
                element3?.classList.remove('no-scroll-bar');
            }
        }
    }

    ngOnInit(): void {
        this.dropdownStates = {
            products: false,
            solutions: false,
            about: false,
            news: false,
            recruit: false,
            language: false,
        };
        this.initLanguage();
        this.initView();
    }

    initView() {
        if (this.isBrowser) this.getScreenWidth = window.innerWidth;
        of(this.layoutService.setPageLoading(true))
            .pipe(
                tap(() => this.resetScroll()),
                tap(() => {
                    // ** 這邊是 animation 的觸發 code
                    // setTimeout(() => {
                    // 	if (this.isBrowser) {
                    // 		const navbar = this.document.querySelector('.navbar') as HTMLElement | null;
                    // 		const banner = this.document.querySelector('.banner_item_1') as HTMLElement | null;
                    // 		const imgBg = document.querySelector('.banner_item_1 .imgBox') as HTMLElement | null;
                    // 		const img = this.document.querySelector(
                    // 			'.banner_item_1 .imgBox .img_main '
                    // 		) as HTMLElement | null;
                    // 		const words = this.document.querySelector('.banner_item_1 .wordBox ') as HTMLElement | null;
                    // 		// if (banner !== null) {
                    // 		img?.classList.add('animate__animated', 'animate__delay-1s');
                    // 		words?.classList.add('animate__animated', 'animate__delay-1s');
                    // 		navbar?.classList.add('animate__animated', 'animate__delay-500ms');
                    // 		if (this.isBrowser) {
                    // 			img?.style?.setProperty('--animate-duration', '1s');
                    // 			words?.style?.setProperty('--animate-duration', '1s');
                    // 			navbar?.style?.setProperty('--animate-duration', '300ms');
                    // 		}
                    // 		// }
                    // 	}
                    // }, this.layoutService.timeout);
                }),
                finalize(() => this.layoutService.setPageLoading(false)),
            )
            .subscribe();
    }

    /**
     * 初始化語系設定
     */
    private initLanguage(): void {
        // 取語系列表
        this.languages = this.languageService.getSupportedLanguages();

        // 設定當前選中的語系
        this.selectedLanguage = this.languageService.getCurrentLang();

        // 監聽語系變更 - 使用setTimeout避免ExpressionChangedAfterItHasBeenCheckedError
        this.languageService.onLanguageChange.subscribe(event => {
            setTimeout(() => {
                this.selectedLanguage = event.lang;
            }, 0);
        });
    }

    /**
     * 下拉語系切換處理
     */
    public onLanguageChange(langCode: string): void {
        this.languageService.setLang(langCode);
        // 選擇語系後關閉下拉選單
        this.setDropdownState('language', false);

        // 如果是手機版，關閉整個選單
        if (this.getScreenWidth <= 1023) {
            this.closeMenu();
        }
    }

    /**
     * 取得當前語系的名稱
     */
    public getCurrentLanguageName(): string {
        return this.languageService.getLanguageDisplayName(this.selectedLanguage);
    }

    ToggleBGFilter() {
        const wrapper = this.document.querySelector('.wrapper');
        const html = this.document.querySelector('html');

        this.isCollapsed = !this.isCollapsed;

        if (!this.isCollapsed) {
            wrapper?.classList.add('filter_blur_2px');
            html?.classList.add('no-scroll-bar');
        } else {
            wrapper?.classList.remove('filter_blur_2px');
            html?.classList.remove('no-scroll-bar');
        }
    }

    navbarMouseEnter(event) {
        const el = event.currentTarget;
        const parentElement = el.closest('ul.navbar-nav');
        const allChildren = parentElement.childNodes;
        if (this.getScreenWidth > 1023) {
            for (const child of allChildren) {
                if (child?.classList) {
                    if (child?.classList.contains('open')) {
                        child?.classList.remove('open', 'show');
                    }
                }
            }
            if (!el?.classList.contains('open')) {
                el?.classList.add('open', 'show');
            }
        }
    }

    navbarMouseLeave(event) {
        const el = event.currentTarget;
        if (this.getScreenWidth > 1023) {
            if (el?.classList.contains('open')) {
                for (const child of el.childNodes[1].childNodes) {
                    if (!child?.classList.contains('open')) {
                        el?.classList.remove('open', 'show');
                    }
                }
            }
        }
    }

    navbarListItemsMouseEnter(event) {
        const el = event.currentTarget;
        if (this.getScreenWidth > 1023) {
            if (!el?.classList.contains('open')) {
                el?.classList.add('open', 'show');
                el.childNodes[1]?.classList.add('open', 'show');
            }
        }
    }

    navbarListItemsMouseLeave(event) {
        if (this.getScreenWidth > 1023) {
            const el = event.currentTarget;
            if (el?.classList.contains('open')) {
                el?.classList.remove('open', 'show');
                el.childNodes[1]?.classList.remove('open', 'show');
            }
        }
    }

    childListMouseEnter(event) {
        const el = event.currentTarget;
        if (this.getScreenWidth > 1023) {
            if (!el?.classList.contains('open')) {
                el.closest('.dropdown.nav-item').add('open', 'show');
                el?.classList.add('open', 'show');
                el.closest('a.dropdown-item')?.classList.add('open', 'show');
            }
        }
    }

    childListMouseLeave(event) {
        if (this.getScreenWidth > 1023) {
            const el = event.currentTarget;
            if (el?.classList.contains('open')) {
                el?.classList.remove('open', 'show');
            }
        }
    }

    resetScroll() {
        const html = this.document.querySelector('html');
        if (html) html.classList.remove('no-scroll-bar');
    }

    ngOnDestroy(): void {
        this.loading = true;
    }

    /** 關閉選單 */
    closeMenu(): void {
        if (this.getScreenWidth <= 1023) {
            this.isCollapsed = true;
            //  this.isDropdownOpen = false;

            const wrapper = this.document.querySelector('.wrapper');
            const html = this.document.querySelector('html');

            wrapper?.classList.remove('filter_blur_2px');
            html?.classList.remove('no-scroll-bar');
        }
    }

    setDropdownState(key: string, isOpen: boolean): void {
        if (this.dropdownTimeout[key]) {
            clearTimeout(this.dropdownTimeout[key]);
        }

        if (isOpen) {
            this.dropdownStates[key] = true;
        } else {
            // 防止閃爍
            this.dropdownTimeout[key] = setTimeout(() => {
                this.dropdownStates[key] = false;
            }, 100);
        }
    }

    /** 任一下拉選單開啟 */
    isAnyDropdownOpen(): boolean {
        return Object.values(this.dropdownStates).some(v => v);
    }

    /** 當前語系是否為英文 */
    isEnglish(): boolean {
        return this.languageService.getCurrentLang() === 'en-us';
    }

    getOpenDropdownIndex(): number {
        const keys = Object.keys(this.dropdownStates);
        return keys.findIndex(k => this.dropdownStates[k]);
    }
}
